import {subscriptionActions} from "../../pages/organisation/subpages/subscription/subscriptionActions";
import {PackageType} from "../../infrastructure/enums/packageType";
import {cloneElement, ReactElement} from "react";
import {useAppDispatch} from "../../infrastructure/hooks/reduxHooks";
import {useSelector} from "react-redux";
import {organisationSelectors} from "../../pages/organisation";

export const LicenseCheck = ({children}: {children: ReactElement}) => {
    
    const dispatch = useAppDispatch();

    const forceSubscription = useSelector(organisationSelectors.getForceSubscription());

    return cloneElement(children, {
        onClick: async (event: any) => {
            if (forceSubscription) {
                dispatch(subscriptionActions.showUpgradeModal({
                    state: true,
                    packageType: PackageType.Server,
                    forceSubscription: true
                }))
                event.preventDefault();
                return;
            }
            if (children!.props.onClick) {
                children!.props.onClick(event);
            }
        },
    });
};